//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'scan_and_category',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};